import axios from 'axios';
import * as types from './Order.types';
import * as selectors from './Order.selectors';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';
import * as shoppingCartSelectors from './../ShoppingCart/ShoppingCart.selectors';

const apiUrl = process.env.REACT_APP_API_URL;

export const placeOrder = (orderType = 1) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const platformType = loginSelectors.getPlatformType(getState());
    const shippingType = shoppingCartSelectors.getShippingType(getState());

    const shipName = selectors.getShipName(getState());
    const shipAddress1 = selectors.getShipAddress1(getState());
    const shipAddress2 = selectors.getShipAddress2(getState());
    const shipCity = selectors.getShipCity(getState());
    const shipState = selectors.getShipState(getState());
    const shipZip = selectors.getShipZip(getState());
    const shipPhone = selectors.getShipPhone(getState());
    const shipEmail = selectors.getShipEmail(getState());
    const shipNotes = selectors.getShipNotes(getState());
    const billName = selectors.getBillName(getState());
    const billAddress1 = selectors.getBillAddress1(getState());
    const billAddress2 = selectors.getBillAddress2(getState());
    const billCity = selectors.getBillCity(getState());
    const billState = selectors.getBillState(getState());
    const billZip = selectors.getBillZip(getState());
    const billPhone = selectors.getBillPhone(getState());
    const billEmail = selectors.getBillEmail(getState());
    const billPo = selectors.getBillPo(getState());
    const billDepartment = selectors.getBillDepartment(getState());
    const billCall = selectors.getBillCall(getState());
    const billNotes = selectors.getBillNotes(getState());
    const cardNumber = selectors.getCardNumber(getState());
    const nameOnCard = selectors.getNameOnCard(getState());
    const expirationMonth = selectors.getExpirationMonth(getState());
    const expirationYear = selectors.getExpirationYear(getState());
    const securityNumber = selectors.getSecurityNumber(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('orderType', orderType);

    formData.append('shipName', shipName);
    formData.append('shipAddress1', shipAddress1);
    formData.append('shipAddress2', shipAddress2);
    formData.append('shipCity', shipCity);
    formData.append('shipState', shipState);
    formData.append('shipZip', shipZip);
    formData.append('shipPhone', shipPhone);
    formData.append('shipEmail', shipEmail);
    formData.append('shipNotes', shipNotes);
    formData.append('billName', billName);
    formData.append('billAddress1', billAddress1);
    formData.append('billAddress2', billAddress2);
    formData.append('billCity', billCity);
    formData.append('billState', billState);
    formData.append('billZip', billZip);
    formData.append('billPhone', billPhone);
    formData.append('billEmail', billEmail);
    formData.append('billPo', billPo);
    formData.append('billDepartment', billDepartment);
    formData.append('billCall', billCall);
    formData.append('billNotes', billNotes);

    formData.append('cardNumber', cardNumber);
    formData.append('nameOnCard', nameOnCard);
    formData.append('expirationMonth', expirationMonth);
    formData.append('expirationYear', expirationYear);
    formData.append('securityNumber', securityNumber);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);
    formData.append('platformType', platformType);
    formData.append('shippingType', shippingType);

    dispatch({ type: types.PLACE_ORDER, payload: null });
    axios.post(apiUrl + '/uthealth-order/place-order', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.PLACE_ORDER_SUCCESS, payload: response.data });
            dispatch(setOrderId(response.data.order_id));
            showNotification('Success', 'The order has been created successfully', 'success');

            if (parseInt(orderType) === 2) {
                document.getElementById('cxml-urlencoded').value = response.data.cxml;
                document.getElementById('cxml-form').submit();
            }
        })
        .catch((error) => {
            dispatch({ type: types.PLACE_ORDER_ERROR, payload: null });
            if (error.response && error.response.status === 406) {
                showNotification('Payment not processed', error.response.data.error.message, 'warning');
            } else if (error.response && error.response.status === 400) {
                showNotification('Not available signs', error.response.data.error.message, 'info');
            } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setShipName = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_NAME,
        payload: value
    });
}
export const setShipAddress1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_ADDRESS_1,
        payload: value
    });
}
export const setShipAddress2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_ADDRESS_2,
        payload: value
    });
}
export const setShipCity = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_CITY,
        payload: value
    });
}
export const setShipState = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_STATE,
        payload: value
    });
}
export const setShipZip = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_ZIP,
        payload: value
    });
}
export const setShipPhone = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_PHONE,
        payload: value
    });
}
export const setShipEmail = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_EMAIL,
        payload: value
    });
}
export const setShipNotes = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHIP_NOTES,
        payload: value
    });
}
export const setBillName = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_NAME,
        payload: value
    });
}
export const setBillAddress1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_ADDRESS_1,
        payload: value
    });
}
export const setBillAddress2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_ADDRESS_2,
        payload: value
    });
}
export const setBillCity = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_CITY,
        payload: value
    });
}
export const setBillState = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_STATE,
        payload: value
    });
}
export const setBillZip = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_ZIP,
        payload: value
    });
}
export const setBillPhone = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_PHONE,
        payload: value
    });
}
export const setBillEmail = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_EMAIL,
        payload: value
    });
}
export const setBillPo = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_PO,
        payload: value
    });
}
export const setBillDepartment = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_DEPARTMENT,
        payload: value
    });
}
export const setBillCall = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_CALL,
        payload: value
    });
}
export const setBillNotes = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BILL_NOTES,
        payload: value
    });
}
export const setSameAddress = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SAME_ADDRESS,
        payload: value
    });
}
export const setCardNumber = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CARD_NUMBER,
        payload: value
    });
}
export const setNameOnCard = (value) => (dispatch) => {
    dispatch({
        type: types.SET_NAME_ON_CARD,
        payload: value
    });
}
export const setExpirationMonth = (value) => (dispatch) => {
    dispatch({
        type: types.SET_EXPIRATION_MONTH,
        payload: value
    });
}
export const setExpirationYear = (value) => (dispatch) => {
    dispatch({
        type: types.SET_EXPIRATION_YEAR,
        payload: value
    });
}
export const setSecurityNumber = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SECURITY_NUMBER,
        payload: value
    });
}
export const setReferenceFiles = (value) => (dispatch) => {
    dispatch({
        type: types.SET_REFERENCE_FILES,
        payload: value
    });
}

export const setOrderId = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ORDER_ID,
        payload: value
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}